import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AuthError } from '@imprivata/nucleus';
import headerImage from '../../images/alert.png';
import * as actions from '../../actions';

/**
 * AuthErrorPage Component
 */
export class AuthErrorPage extends Component {
  /**
   * The allowed properties for the AuthErrorPage component
   * @param {function} startSession The function that begins the session
   * @param {string} accountToken The account token for the session
   * @param {string} environment the applex cloud we are connecting to. Examples are dev, integration, staging, and prod
   * @param {string} sessionException The session error that got thrown
   */
  static propTypes = {
    startSession: PropTypes.func,
    accountToken: PropTypes.string,
    environment: PropTypes.string,
    sessionException: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  };

  acceptClick = () => {
    this.props.startSession(this.props.accountToken, this.props.environment);
  };

  render() {
    const { sessionException, } = this.props;
    const cleanException = (sessionException && sessionException.code) ? sessionException.code : 'unknownError';

    return (
      <div className='content-body'>
        <AuthError
          headerImage={headerImage}
          headerTitle='Sorry'
          headerDescription={
            <div>
              <div>There is a problem. Contact your help desk.</div>
              <div>({cleanException})</div>
            </div>
          }
          onAcceptClick={this.acceptClick}
        />
      </div>
    );
  }
}


const mapStateToProps = state => {
  const {
    accountToken, environment, sessionException,
  } = state.login;
  return {
    accountToken,
    environment,
    sessionException,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startSession: (accountToken, environment) => {
      dispatch(actions.startSession(accountToken, environment) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthErrorPage);
